// Waitlist delivery via Web3Forms (https://web3forms.com) — zero-backend
// form-to-email. The access key is a *public* client-side key tied to the
// destination inbox: get one by entering support@wickscope.com on their site
// and paste it below. While the key is empty the UI falls back to the
// pre-filled mailto link.
const WEB3FORMS_ACCESS_KEY = "57b60f6c-f4d5-47c6-974d-234e50632449";

const WEB3FORMS_ENDPOINT = "https://api.web3forms.com/submit";

export const WAITLIST_MAILTO =
  "mailto:support@wickscope.com" +
  `?subject=${encodeURIComponent("WickScope beta waitlist")}` +
  `&body=${encodeURIComponent(
    "Hi WickScope team,\n\nPlease add me to the beta waitlist.\n\nName:\nMarkets I trade:\n",
  )}`;

export function hasWaitlistKey(): boolean {
  return WEB3FORMS_ACCESS_KEY.length > 0;
}

export interface WaitlistEntry {
  email: string;
  name: string;
  markets: string;
}

/** POSTs the entry to Web3Forms; resolves true when it was accepted. */
export async function submitWaitlist(entry: WaitlistEntry): Promise<boolean> {
  try {
    const res = await fetch(WEB3FORMS_ENDPOINT, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({
        access_key: WEB3FORMS_ACCESS_KEY,
        subject: "WickScope beta waitlist signup",
        from_name: "WickScope waitlist",
        email: entry.email,
        name: entry.name || "(not given)",
        message: `Markets traded: ${entry.markets || "(not given)"}`,
      }),
    });
    if (!res.ok) return false;
    const data: unknown = await res.json();
    return (
      typeof data === "object" &&
      data !== null &&
      (data as { success?: boolean }).success === true
    );
  } catch {
    return false;
  }
}
